import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, Tab, Tabs } from "@mui/material";

interface FormTabsProps {
  tab: 'details' | 'invoice' | 'payments';
  disabled: boolean;
  onTabChange: (e: any, value: 'details' | 'invoice' | 'payments') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, disabled, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor='primary' className="pt-2" variant="fullWidth">
        <Tab value="details" label={t("invoices.editPreviewPayment.pageTexts.form.tabs.details")} />
        <Tab
          value="invoice"
          label={(
            <Tooltip
              title={disabled && t("invoices.editPreviewPayment.pageTexts.form.tabs.enableTabInstructions")}
              arrow
              classes={{ tooltip: "tooltip" }}
            >
              <div className="w-100 h-100">{t("invoices.editPreviewPayment.pageTexts.form.tabs.invoice")}</div>
            </Tooltip>
          )}
          disabled={disabled}
          classes={{ disabled: 'pe-auto' }}
        />
        <Tab
          value="payments" 
          label={(
            <Tooltip
              title={disabled && t("invoices.editPreviewPayment.pageTexts.form.tabs.enableTabInstructions")}
              arrow
              classes={{ tooltip: "tooltip" }}
            >
              <div className="w-100 h-100">{t("invoices.editPreviewPayment.pageTexts.form.tabs.payments")}</div>
            </Tooltip>
          )}
          disabled={disabled} 
          classes={{ disabled: 'pe-auto' }}
        />
      </Tabs>
    </div>
  );
};

export default FormTabs;